<template>
<div :style="{ 'pointer-events': disableInteraction ? 'none' : 'auto' }">
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickPasswordChange)" autocomplete="off" v-can="'view-supplier'">
        <vx-card class="my-8">
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-chip class="float-right" transparent v-if="form.is_approved === 4"  color="danger">
                status: Not Approved
              </vs-chip>
              <vs-chip class="float-right" transparent  v-if="form.is_approved === 3"  color="success">
                status: Approved
              </vs-chip>
              <vs-chip class="float-right" transparent  v-if="form.is_approved === 2"  color="warning">
                status: Pending Approval
              </vs-chip>
              <vs-chip class="float-right" transparent  v-if="form.is_approved === 1"  color="warning">
                status: SAQ Pending
              </vs-chip>
              <vs-chip class="float-right" transparent  v-if="form.is_approved === 0"  color="warning">
                status: Pending Verification
              </vs-chip>
            </div>
          </div>

          <vs-divider class="mt-8 mb-12" color="primary" position="center">General Information</vs-divider>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input readonly  type="text" name="company_name" class="w-full" v-model="company_name" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">

            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="email" class="w-full" v-model="form.email" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="form.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <div class="vx-row">
                <div class="vx-col w-1/3">
                  <ValidationProvider vid="telephone_country_code" name="telephone_country_code" rules="required" v-slot="{ errors }">
                    <small class="label">Country Code</small>
                    <v-select :filter-by="myFilter"  :clearable="false" name="telephone_country_code" placeholder="" label="isd_code" v-model="form.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.isd_code}} - {{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-2/3">
                  <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                    <small class="label">Supplier Telephone</small>
                    <vs-input name="site_telephone"  class="w-full required" label="" v-model="form.telephone" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <div class="vx-row">
                <div class="vx-col w-1/3">
                  <ValidationProvider vid="fax_country_code" name="fax_country_code" rules="" v-slot="{ errors }">
                    <small class="label">Country Code</small>
                    <v-select :filter-by="myFilter" :clearable="false" name="fax_country_code" placeholder="" label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.isd_code}} - {{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-2/3">
                  <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                    <small class="label">Supplier Fax</small>
                    <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax" />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
                <small class="label">Do you have a Company VAT Registration?</small>
                <vs-switch v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col w-2/5">
              <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country" name="is_vat_registration_country" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, In which country are you registered</small>
                <v-select :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder="" label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text" name="is_vat_registration_text" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, Company VAT Registration</small>
                <vs-input type="text" name="is_vat_registration_text" class="w-full" v-model="form.is_vat_registration_text"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
                <small class="label">Do you have a Company Registration Number?</small>
                <vs-switch v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col w-2/5">
              <ValidationProvider v-if="form.is_registration" vid="is_registration_country" name="is_registration_country" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, In which country are you registered</small>
                <v-select :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder="" label="name" v-model="form.is_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, Company Registration Number</small>
                <vs-input type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="supplier_status" name="supplier_status" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Status</small>
                <v-select  label="name" :closeOnSelect="true" v-model="form.supplier_status" :options="['manufacturer','trader','packer']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.supplier_status === 'trader' ||  form.supplier_status === 'packer'" vid="supplier_identity" name="supplier_identity" rules="required" v-slot="{ errors }">
                <small class="label">Identity of manufacturer</small>
                <vs-input type="text" name="supplier_identity" class="w-full" v-model="form.supplier_identity"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

        </vx-card>

        <vx-card titleColor="#736F6E" title="Contacts" class="my-8">

          <vs-row vs-w="12" class="mt-4">
            <vs-col v-for="(contact, index) in supplier_contacts" :key="index+'contact'"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="6" vs-sm="6" vs-xs="12"
                    class="px-4 pb-4">
              <vx-card-custom :cardBorder="true" no-shadow :remove-card-action="!(contact.type === 'emergency' && index === 0)"  v-on:remove="deleteContact(index)" :collapse-action="false">

                <div class="vx-row mb-2">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider :vid="index+'contact_type'" :name="index+'contact_type'" rules="required" v-slot="{ errors }">
                      <small class="label">Contact Type</small>
                      <v-select :disabled="contact.type === 'emergency' && index === 0" label="name" :closeOnSelect="true" v-model="contact.type" :options="['technical','commercial','emergency']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>


                <div class="vx-row mb-2">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index+'contact_name'" :name="index+'contact_name'" rules="required" v-slot="{ errors }">
                      <small class="label">Contact Name</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_name" label=""  class="w-full required"  v-model="contact.name"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="contact.type !== 'emergency'">
                    <ValidationProvider :vid="index+'contact_email'" :name="index+'contact_email'" rules="" v-slot="{ errors }">
                      <small class="label">Contact Email</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_email" label=""  class="w-full required"  v-model="contact.email"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="contact.type === 'emergency'">
                    <ValidationProvider :vid="index+'position'" :name="index+'position'" rules="required" v-slot="{ errors }">
                      <small class="label">Contact Position</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_position" label=""  class="w-full required"  v-model="contact.position"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-2">
                  <div class="vx-col w-2/5">
                    <ValidationProvider :vid="index+'site_telephone_code'" :name="index+'site_telephone_code'" rules="required" v-slot="{ errors }">
                      <small class="label">Country Code</small>
                      <v-select :filter-by="myFilter" :clearable="false"  label="isd_code" v-model="contact.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{option.isd_code}} - {{option.name}} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-3/5">
                    <ValidationProvider :vid="index+'site_telephone'" :name="index+'site_telephone'" rules="required|tel|max:15" v-slot="{ errors }">
                      <small class="label">Contact Telephone</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="telephone"  class="w-full required" label="" v-model="contact.telephone"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-2" v-if="contact.type !== 'emergency'">
                  <div class="vx-col w-2/5">
                    <ValidationProvider :vid="index+'site_country_code_mobile'" :name="index+'site_country_code_mobile'" rules="" v-slot="{ errors }">
                      <small class="label">Country Code</small>
                      <v-select :filter-by="myFilter" :clearable="false"  label="isd_code" v-model="contact.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{option.isd_code}} - {{option.name}} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-3/5">
                    <ValidationProvider :vid="index+'site_mobile'" :name="index+'site_mobile'" rules="tel|max:15" v-slot="{ errors }">
                      <small class="label">Contact Mobile</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="mobile"  class="w-full required" label="" v-model="contact.mobile"/>
                    </ValidationProvider>
                  </div>
                </div>

              </vx-card-custom>
            </vs-col>
          </vs-row>
          <vs-button class="mt-4 mb-4 ml-4" @click="addNewContact()" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add contact</vs-button>
        </vx-card>

<!--        <vx-card class="my-8">-->
<!--          <vs-divider class="mt-8 mb-12" color="primary" position="center">Contacts</vs-divider>-->
<!--          <div class="vx-row mb-3 mt-8" v-for="(contact, index) in supplier_contacts" :key="index+'contact'">-->
<!--            <div class="vx-col w-1/4">-->
<!--              <ValidationProvider :vid="index+'contact_type'" :name="index+'contact_type'" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Contact Type</small>-->
<!--                <v-select  label="name" :closeOnSelect="true" v-model="contact.type" :options="['technical','commercial','emergency']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col w-1/4">-->
<!--              <ValidationProvider :vid="index+'contact_name'" :name="index+'contact_name'" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Contact Name</small>-->
<!--                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_name" label=""  class="w-full required"  v-model="contact.name"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col w-1/4">-->
<!--              <div class="vx-row">-->
<!--                <div class="vx-col w-1/3">-->
<!--                  <ValidationProvider :vid="index+'site_telephone_code'" :name="index+'site_telephone_code'" rules="required" v-slot="{ errors }">-->
<!--                    <small class="label">Country Code</small>-->
<!--                    <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="contact.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
<!--                      <template v-slot:option="option">-->
<!--                        <span>{{option.isd_code}} - {{option.name}} </span>-->
<!--                      </template>-->
<!--                    </v-select>-->
<!--                    <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--                <div class="vx-col w-2/3">-->
<!--                  <ValidationProvider :vid="index+'site_telephone'" :name="index+'site_telephone'" rules="required|tel|max:15" v-slot="{ errors }">-->
<!--                    <small class="label">Contact Telephone</small>-->
<!--                    <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="telephone"  class="w-full required" label="" v-model="contact.telephone"/>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="supplier_contacts.length > 2" class="vx-col w-1/4">-->
<!--              <vs-button color="danger" icon="delete"  @click="deleteContact(index)" type="border" class="ml-auto mt-6 w-full" >Delete</vs-button>-->
<!--            </div>-->
<!--            <div class="vx-col w-1/4" v-if="contact.type !== 'emergency'">-->
<!--              <div class="vx-row">-->
<!--                <div class="vx-col w-1/3">-->
<!--                  <ValidationProvider :vid="index+'site_country_code_mobile'" :name="index+'site_country_code_mobile'" rules="" v-slot="{ errors }">-->
<!--                    <small class="label">Country Code</small>-->
<!--                    <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="contact.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
<!--                      <template v-slot:option="option">-->
<!--                        <span>{{option.isd_code}} - {{option.name}} </span>-->
<!--                      </template>-->
<!--                    </v-select>-->
<!--                    <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--                <div class="vx-col w-2/3">-->
<!--                  <ValidationProvider :vid="index+'site_mobile'" :name="index+'site_mobile'" rules="tel|max:15" v-slot="{ errors }">-->
<!--                    <small class="label">Contact Mobile</small>-->
<!--                    <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="mobile"  class="w-full required" label="" v-model="contact.mobile"/>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="vx-col w-1/4" v-if="contact.type !== 'emergency'">-->
<!--              <ValidationProvider :vid="index+'contact_email'" :name="index+'contact_email'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Contact Email</small>-->
<!--                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_email" label=""  class="w-full required"  v-model="contact.email"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col w-1/4" v-if="contact.type === 'emergency'">-->
<!--              <ValidationProvider :vid="index+'position'" :name="index+'position'" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Contact Position</small>-->
<!--                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_position" label=""  class="w-full required"  v-model="contact.position"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;        <vs-button  @click="addNewContact" class="ml-auto mt-2" >Add New Contact</vs-button>&ndash;&gt;-->
<!--&lt;!&ndash;          <vs-button  @click="addNewContact" radius color="primary" type="filled" icon="add"></vs-button>&ndash;&gt;-->
<!--          <vs-button class="mt-8" @click="addNewContact" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-plus">Add Contact</vs-button>-->

<!--        </vx-card>-->

        <vx-card class="my-8">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider vid="is_product_liability_insurance_cover" name="is_product_liability_insurance_cover" rules="" v-slot="{ errors }">
                <small class="label">1.1 Do you have Product Liability Insurance Cover? </small>
                <vs-switch v-model="supplier_additional_detail.is_product_liability_insurance_cover" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-4/5 w-full md:mb-0">
              <ValidationProvider v-if="supplier_additional_detail.is_product_liability_insurance_cover" vid="is_product_liability_insurance_cover_text" name="is_product_liability_insurance_cover_text" rules="required" v-slot="{ errors }">
                <small class="label">If yes, state limit of Liability (£ GBP)</small>
                <vs-input  type="text" name="is_product_liability_insurance_cover_text" class="w-full" v-model="supplier_additional_detail.is_product_liability_insurance_cover_text"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-8">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider vid="is_sedex_member" name="is_sedex_member" rules="" v-slot="{ errors }">
                <small class="label">1.5 Are you members of Sedex?</small>
                <vs-switch v-model="supplier_additional_detail.is_sedex_member" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-4/5 w-full md:mb-0" v-if="supplier_additional_detail.is_sedex_member">
              <ValidationProvider  vid="is_sedex_member_yes" name="is_sedex_member_yes" rules="required" v-slot="{ errors }">
                <small class="label">If yes, please set up a direct link with ITS (ITS Membership number : ZC1086963)</small>
                <vs-input type="text" name="is_sedex_member_yes" class="w-full" v-model="supplier_additional_detail.is_sedex_member_yes"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-4/5 w-full md:mb-0"  v-if="!supplier_additional_detail.is_sedex_member">
<!--              <ValidationProvider vid="is_sedex_member_file" name="is_sedex_member_file" rules="" v-slot="{ errors }">-->
<!--                <small class="label">If not, please provide Ethical Policy</small>-->
<!--                <a target="_blank" v-if="supplier_additional_detail.is_sedex_member_file" class="float-right" :href="supplier_additional_detail.is_sedex_member_file">view file</a>-->
<!--                <vs-input  @change="onUploadSedexFile($event)" type="file" name="is_sedex_member_file" class="w-full" />-->
<!--                <span v-if="formUploadRequiredSedex" class="text-danger text-sm">This field is required</span>-->
<!--              </ValidationProvider>-->

              <small class="label">If not, please provide Ethical Policy</small>
              <file-uploader
                v-on:onSetFileName="value => supplier_additional_detail.is_sedex_member_file = value"
                v-on:onClickFileRemove="supplier_additional_detail.is_sedex_member_file = null"
                :file="supplier_additional_detail.is_sedex_member_file"
                :condition="!supplier_additional_detail.is_sedex_member"
              />

            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end" v-can="'edit-supplier'">
            <vs-button button="submit" class="ml-auto mt-2" >Save Changes</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </vx-card>
      </form>
    </ValidationObserver>
</div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  const SupplierRepository = RepositoryFactory.get('supplier');
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import FileUploader from '@/components/shared/FileUploader'


  function initialState() {
    return {
      old_password: '',
      password: '',
      password_confirmation: '',
      file: 'sdasd.pdf',
      quantity: null,
      company_name: null,
      form: {
        is_vat_registration: false,
        is_registration: false
      },
      supplier_accreditation: {},
      supplier_additional_detail: {
        is_product_liability_insurance_cover: false,
        is_sedex_member: false
      },
      certification_file: null,
      supplier_accreditation_file: null,
      supplier_contacts: [],
      countryCodes: [],
      formUploadRequiredSedex: false,
      formUploadRequired: false,
    }
  }
  export default {
    mixins: [SuccessMessage, ErrorMessages],
    data () {
      return initialState()
    },
    components: {
      'v-select': vSelect,
      Datepicker,
      flatPickr,
      FileUploader
    },
    computed: {
      disableInteraction: function() {
        return !this.$can('edit-supplier')
      }
    },
    methods: {
      successUpload(){
        this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
      },
      addNewContact: function(type) {
        this.supplier_contacts.push(
          {type: type ? type : '', name : '', telephone : '', country_code_telephone: ''}
        )
      },
      addNewGfsi: function() {
        this.supplier_GFSIs.push(
          {type: 'GFSI', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null}
        )
      },
      addNewAccreditations: function() {
        this.supplier_other_accreditations.push(
          {type: 'Other', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null}
        )
      },
      deleteContact: function(index) {
        this.supplier_contacts.splice(index, 1)
      },
      deleteGfsi: function(index) {
        this.supplier_GFSIs.splice(index, 1)
      },
      deleteAccreditations: function(index) {
        this.supplier_other_accreditations.splice(index, 1)
      },
      async onUploadCerticiation(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.supplier_additional_detail.certification = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadSedexFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.supplier_additional_detail.is_sedex_member_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequiredSedex = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadAccreditaionFile(event, index){
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.supplier_other_accreditations[index].file = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadGFSIS(event, index){
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.supplier_GFSIs[index].file = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickPasswordChange() {
          let payload = this.form
          payload.supplier_contacts = this.supplier_contacts
          payload.supplier_additional_detail = this.supplier_additional_detail
          this.$vs.loading();

          try {
            const change = await SupplierRepository.updateSupplierBasicDetails(payload);
            this.showSuccessMessage('Supplier Profile Update Successfully!')
            // this.clearFormData();
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
      },

      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      clearFormData() {
        this.password = '';
        this.old_password = '';
        this.password_confirmation = '';
      },
      uploadJanaka() {

      },
      // doSomethingInParentComponentFunction(index) {
      //   this.supplier_GFSIs[index].last_audit = moment(this.supplier_GFSIs[index].last_audit).format("dd/MM/yyyy")
      //   console.log(this.supplier_GFSIs[index].last_audit)
      // },
      // onClickGfsiExpiry(index) {
      //   this.supplier_GFSIs[index].expiry = moment(this.supplier_GFSIs[index].expiry).format("dd/MM/yyyy")
      //   console.log(this.supplier_GFSIs[index].expiry)
      // },
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      }
    },
    async mounted() {
      this.$vs.loading()
      const {data} = (await SupplierRepository.getBasicSupplierDetails()).data
      this.countryCodes =  (await SupplierManufactureRepository.getCountryCodes()).data.data
      console.log(data)
      if(data.is_complete_details === 1) {
        this.supplier_contacts =  data.contacts.map((m) => {
          let n = {}
          n.type = m.type
          n.name = m.data.name
          n.email = m.data.email
          n.telephone = m.data.telephone
          n.mobile = m.data.mobile
          n.country_code_telephone = m.data.country_code_telephone
          n.country_code_mobile = m.data.country_code_mobile
          if(m.type === 'emergency') {
            n.position = m.data.position
          }
          return n
        })
        this.form = data
        this.company_name = data.company_name
        this.supplier_additional_detail = this.form.supplier_additional_detail
      } else {
        if (data.contacts.length !==0) {
          this.supplier_contacts =  data.contacts.map((m) => {
            let n = {}
            n.type = m.type
            n.name = m.data.name
            n.email = m.data.email
            n.telephone = m.data.telephone
            n.mobile = m.data.mobile
            n.country_code_telephone = m.data.country_code_telephone
            n.country_code_mobile = m.data.country_code_mobile
            if(m.type === 'emergency') {
              n.position = m.data.position
            }
            return n
          })
        }
        this.addNewContact('emergency')
        this.form.company_name = data.company_name
        this.company_name = data.company_name
        this.form.company_name_unique = data.company_name_unique
        this.form.telephone = data.telephone
        this.form.is_approved = data.is_approved
      }
      this.$vs.loading.close()
    }
  }
</script>

<style>
  /*input[type="file"] {*/
  /*  position: fixed;*/
  /*  right: 100%;*/
  /*  bottom: 100%;*/
  /*}*/
  /*.fileUpload input.upload {*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  right: 0;*/
  /*  margin: 0;*/
  /*  padding: 0;*/
  /*  font-size: 20px;*/
  /*  cursor: pointer;*/
  /*  opacity: 0;*/
  /*  filter: alpha(opacity=0);*/
  /*  width: 148px;*/
  /*  height: 46px;*/
  /*  cursor: pointer;*/
  /*}*/
  /*.fileUpload:hover, .fileUpload:active, .fileUpload:focus {*/
  /*  background: #00a2a4;*/
  /*  cursor: pointer;*/
  /*}*/
  /*.custom-file-upload {*/
  /*  border: 1px solid #ccc;*/
  /*  display: inline-block;*/
  /*  padding: 6px 12px;*/
  /*  cursor: pointer;*/
  /*  background-color: #28C76F;*/
  /*  color:white*/
  /*}*/
</style>
